import React, { useState } from "react";
import axios from "axios";
import './tenant.css';
import { showSuccessToast, showErrorToast } from '../toast-utils';
import { tenant_onboard } from "../apis";

function Tenant(props) {
  const [formData, setFormData] = useState({
    tenantName: '',
    product: '',
  });
  const [formErrors, setFormErrors] = useState({});
  const [touchedFields, setTouchedFields] = useState({});
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const onboardTenant = () => {
    let userToken = getCurrentUserToken();
    if (!userToken) {
      console.error("User token not found");
      return;
    }
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${userToken}`
    }
    const payload = {
      tenant_name: formData.tenantName,
      product: formData.product
    }

    axios.post(tenant_onboard, payload, { headers: headers })
      .then(response => {
        showSuccessToast("New tenant successfully created");
      })
      .catch(error => {
        if (error.response && error.response.data.msg === "Token has expired") {
          props.onLogout('token');
        }
      })
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleInputBlur = (e) => {
    const { name } = e.target;
    setTouchedFields((prevTouched) => ({
      ...prevTouched,
      [name]: true,
    }));
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.tenantName) {
      errors.tenantName = 'Tenant Name is required';
    }
    if (!formData.product) {
      errors.product = 'Product name is required';
    }
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const getCurrentUserToken = () => {
    const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    return currentUser.token || '';
  }

  const handleSubmit = (e) => {
    setIsButtonDisabled(true);
    e.preventDefault();
    setTouchedFields({
      tenantName: true,
      product: true,
    });
    const isFormValid = validateForm();
    if (isFormValid) {
      setFormData((prevData) => ({
        ...prevData,
      }))
      onboardTenant();
    } else {
      console.log('Please fill the required field.');
    }
    setIsButtonDisabled(false);
  }

  return (
    <div className="main-tenant d-flex flex-column align-items-start justify-content-start">
      <div className="head">
        <span className="title">Tenant Onboarding</span>
      </div>
      <div className="body">
        <form className="form" onSubmit={handleSubmit}>
          <div className="items">
            <div className="item1">
              <label>Tenant name</label>
              <input type="text" name="tenantName" value={formData.tenantName} onChange={handleInputChange} onBlur={handleInputBlur} />
              {touchedFields.tenantName && !formData.tenantName && <span className="error-message">{formErrors.tenantName}</span>}
            </div>
            <div className="item2">
              <label>Product</label>
              <select style={{ height: "28px", width: "100px" }} name="product" value={formData.product} onChange={handleInputChange} onBlur={handleInputBlur}>
                <option value="" disabled selected>Select</option>
                <option value="adaptive">adaptive</option>
                <option value="zero_trust">zero trust</option>
                <option value="passwordless">passwordless</option>
              </select>
              {touchedFields.product && !formData.product && <span className="error-message">{formErrors.product}</span>}
            </div>
            <div className="submit-ten">
              <button type="submit" disabled={isButtonDisabled} className={isButtonDisabled ? 'disabledButton' : 'btn btn-default'}>Submit</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Tenant;
